import httpClient from "../utils/httpClient";

export const styleSearch = async (payload) => {
    const response = await httpClient.post("/Jewellery/StyleSearch", payload);
    return response.data;
};

export const styleSearchDetail = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/StyleSearchDetail', requestParams);
    return response.data;
};

export const QuickView = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/GetQuickViewData', requestParams);
    return response.data;
};